import { AfsServiceDetailVo, LocalInfoDTO } from '@/apis/afterSales/afterSales.interface';
import { useTranslation } from '@/i18n/client';
import cn from 'clsx';
import { useState } from 'react';
import styles from './index.module.scss';
// 组件
import RefundTipsModal from '@/app/csr-src/pages/order/components/refundTipsModal';
import CouponCard from '@/app/csr-src/pages/profile/voucher/components/couponCard/index';
// 图标
import TipIcon from '@/assets/icons/TipIcon.svg';
import VectorDown from '@/assets/icons/VectorDownBig.svg';
// utils
import { formatInteger } from '@/utils/priceUtils';

interface detailInfoProps {
  afsDetailInfo: AfsServiceDetailVo;
  localInfo: LocalInfoDTO;
}
const RefundDetails = ({ afsDetailInfo, localInfo }: detailInfoProps) => {
  const { t } = useTranslation();
  const { refundAmountStr, couponInfos, refundItems, returnPoints, showReturnPoints } =
    afsDetailInfo || {};
  const amountText = t('afterSales.refundDetails.amountText');
  const couponText = t('afterSales.refundDetails.couponText');

  const [showRefundTipsModal, setShowRefundTipsModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [isItemVisible, setIsItemVisible] = useState(false);

  // 展开与收起功能
  const toggleExpand = () => {
    setIsItemVisible(!isItemVisible);
  };

  return (
    <div className={styles.detailLeftWrap}>
      <div className={styles.refundItemTitle}>
        <div className={styles.refundItemCommonTitle}>
          {/* Estimated refund amount and method */}
          {t('order.orderDetail.refundModal.modalTitle')}
        </div>
      </div>
      <div
        className={cn(styles.refundItemDescWrap, styles.refundItemClickStyle)}
        onClick={() => {
          setShowRefundTipsModal(true);
          setModalContent(amountText);
        }}
      >
        <div>{t('afterSales.refundDetails.refundTipText')}</div>
        <TipIcon />
      </div>
      <div className={styles.refundItemSubTitle}>
        <div>{t('afterSales.refundDetails.refundAmount')}</div>
        <div>{refundAmountStr}</div>
      </div>
      {/* 金额细项 */}
      {!!refundItems?.length && (
        <ul className={styles.priceDetailWrap}>
          {refundItems?.map((item, index) => {
            return (
              <li key={`afsChildPrice${index}`}>
                <div>{item?.title}</div>
                <div>
                  {localInfo?.currencySymbol}
                  {item?.amount}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {/* 退还积分 */}
      {showReturnPoints && (
        <div className={styles.refundItemSubTitle}>
          <div>{t('afterSales.refundDetails.returnedPoints')}</div>
          <div>{formatInteger(returnPoints || 0)}</div>
        </div>
      )}
      {!!couponInfos?.length && (
        <div
          className={cn(styles.refundItemSubTitle, styles.refundItemClickStyle)}
          onClick={toggleExpand}
        >
          <div className={styles.refundItemLeftWrap}>
            <div>{t('afterSales.refundDetails.returnedCoupon')}</div>
            <TipIcon
              className={styles.tipIco}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                setShowRefundTipsModal(true);
                setModalContent(couponText);
              }}
            />
          </div>
          <VectorDown
            className={cn(styles.moreIco, {
              [styles.retractIco]: isItemVisible,
            })}
          />
        </div>
      )}
      {isItemVisible && !!couponInfos?.length && (
        <div>
          <CouponCard
            data={couponInfos}
            currentTab='available'
            containerStyle={{ width: '100%', marginBottom: '8px' }}
            contentStyle={{ width: '530px' }}
            isShowUseBtn={false}
            currency={localInfo?.currencySymbol}
          />
        </div>
      )}

      {/* <div className={styles.couponDesc}>
      1 coupon(s) for specific items has be returned as it meets the return rules.
    </div> */}
      {showRefundTipsModal && (
        <RefundTipsModal
          isOpen={showRefundTipsModal}
          content={modalContent}
          closeHandler={() => setShowRefundTipsModal(false)}
        />
      )}
    </div>
  );
};

export default RefundDetails;
